import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import BackToPreviousPageButton from '../../../components/Button/BackToPreviousPageButton';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import TableGroup from '../../../components/Table/TableGroup';
import { DRIVER_LIST, HIRING_CONFLICTS } from '../../../routes/routeConstants';
import ConflictsResponseList from './ConflictsResponseList';
import ReceivedConflictsList from './ReceivedConflictsList';

const HiringConflictsList = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver list`,
        link: `/${DRIVER_LIST}`,
      },
      {
        name: `Hiring Conflicts`,
        link: `/${HIRING_CONFLICTS}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);
  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <BackToPreviousPageButton path={DRIVER_LIST} />
        <Container>
          <TableGroup titles={['Received Conflicts', 'Conflict Response']}>
            <ReceivedConflictsList />
            <ConflictsResponseList />
          </TableGroup>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default HiringConflictsList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
